import React from "react";
import { Badge } from "antd";
import { Droppable } from "@hello-pangea/dnd";
import CRMCard from "./CRMCard";
import { DollarOutlined } from "@ant-design/icons";

const fmtCurrency = (val) => {
  if (!val) return "$0";
  if (val >= 1_000_000) return `$${(val / 1_000_000).toFixed(1)}M`;
  if (val >= 1_000) return `$${(val / 1_000).toFixed(1)}K`;
  return `$${val}`;
};
export default function CRMColumn({
  column,
  cards,
  allColumns,
  onCardClick,
  onMoveColumn,
  onDeleteCard,
  unreadCounts,
}) {
  const totalValue = cards.reduce(
    (sum, c) => sum + (Number(c.projectValue) || 0),
    0,
  );
  return (
    <div className="crm-column">
      {/* Column Header */}
      <div className="crm-column-header" style={{ borderColor: column.color }}>
        <div className="crm-column-title-row">
          <span
            className="crm-column-dot"
            style={{ background: column.color }}
          />
          <span className="crm-column-label">{column.label}</span>
        </div>
        <div className="crm-column-header-right">
          {/* Total project value */}
          <span
            className="crm-column-total-value"
            style={{ color: column.color }}
          >
            <DollarOutlined style={{ fontSize: 11, marginRight: 2 }} />
            {fmtCurrency(totalValue)}
          </span>

          {/* Card count badge */}
          <Badge
            count={cards.length}
            style={{ backgroundColor: column.color }}
            showZero
          />
        </div>
        {/* <Badge
          count={cards.length}
          style={{ backgroundColor: column.color }}
          showZero
        /> */}
      </div>

      {/* Droppable zone */}
      <Droppable droppableId={column.key}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={`crm-column-body ${
              snapshot.isDraggingOver ? "crm-column-body--over" : ""
            }`}
          >
            {cards.length === 0 && !snapshot.isDraggingOver ? (
              <div className="crm-column-empty">
                Drop cards here or create a new requirement
              </div>
            ) : (
              cards.map((card, index) => (
                <CRMCard
                  key={card._id}
                  card={card}
                  index={index}
                  accentColor={column.color}
                  currentColumn={column}
                  allColumns={allColumns}
                  onClick={() => onCardClick(card)}
                  onMoveColumn={onMoveColumn}
                  onDelete={onDeleteCard}
                  unreadCount={unreadCounts?.[String(card._id)] || 0}
                />
              ))
            )}
            {/* Placeholder keeps column height stable while dragging */}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
}
